export const RoutePermissionMap: Record<string, string[]> = {
  dashboard: ['leaderboards', 'marketing', 'bugReport'],
  settings: ['country', 'scripts', 'prizeZone', 'league', 'gateways'],
  dff: [
    'contest',
    'dffGameFixture',
    'dffMatchUsers',
    'dffSeason',
    'gameFixture',
    'gamePrize',
    'simulate',
  ],
  sff: [
    'sffSeasonLeague',
    'sffMdPrizeZone',
    'sffLeagueUser',
    'sffMdUserTeam',
    'sffMdMatches',
    'sffUserTeam',
  ],
  accounts: [
    'rftBank',
    'payment',
    'payout',
    'sffTransaction',
    'dffTransaction',
  ],
  users: ['user', 'adminOnboard'],
  assets: ['assets'],
  notification: ['notification'],
  subscription: [
    'sffSubscription',
    'rftcPack',
    'leaguePack',
    'paidTransferPacks',
  ],
  survey: ['survey'],
  'refer-earn': ['rftReferral'],
};
